import { schema } from 'normalizr'

const tableSeat = new schema.Entity('tableSeats')

export default tableSeat
